export default {
    surveyReview: {
        good_review: {active: null, content: []},
        bad_review: {active: null, content: []}
    },
    googleReview: {
        good_review: {active: null, content: []},
        bad_review: {active: null, content: []}
    },
    staffRatingAnswerList: {},
    deviceList: {},
    reviewList: [],
    reviewData: {items: [], _links: {}, _meta: {}},
    reviewReport: null,
    chartOptions: {
        plotOptions: {
            radialBar: {
                size: 110,
                startAngle: -150,
                endAngle: 150,
                hollow: {
                    size: '77%',
                },
                track: {
                    background: "#bfc5cc",
                    strokeWidth: '50%',
                },
                dataLabels: {
                    name: {
                        show: false
                    },
                    value: {
                        offsetY: 18,
                        color: '#99a2ac',
                        fontSize: '4rem'
                    }
                }
            }
        },
        // colors: ['#00db89'],
        colors: ['#74A4F7'],
        fill: {
            type: 'gradient',
            gradient: {
                shade: 'dark',
                type: 'horizontal',
                shadeIntensity: 0.5,
                // gradientToColors: ['#00b5b5'],
                gradientToColors: ['#2979FF'],
                inverseColors: true,
                opacityFrom: 1,
                opacityTo: 1,
                stops: [0, 100]
            },
        },
        stroke: {
            lineCap: 'round'
        },
        chart: {
            sparkline: {
                enabled: true,
            },
            dropShadow: {
                enabled: true,
                blur: 3,
                left: 1,
                top: 1,
                opacity: 0.1
            },
        },
    },


    // Review list new
    allReviewListData: {items: [], _links: {}, _meta: {}},
    gocheckinReviewListData: {items: [], _links: {}, _meta: {}},
    yelpReviewListData: {items: [], _links: {}, _meta: {}},
    googleReviewListData: {items: [], _links: {}, _meta: {}},
    messageListData:  {items: [], _links: {}, _meta: {}},
    staffRatingList: {}
}
